import { useEffect } from 'react'
import { NumberInput, Text } from '@mantine/core'
import type { TaskArgsComponentProps } from '../args-registry'
import { DEFAULT_DAYS, extractRetainDays, MAX_DAYS, MIN_DAYS } from './PruneTaskRunsArgs.utils'

/** Args editor/viewer for prune-task-runs: { retain_days } within 30–365. */
export function PruneTaskRunsArgs({ value, onChange, readOnly }: TaskArgsComponentProps) {
  const days = extractRetainDays(value)

  // Edit mode seeded with no args (scheduled_args unset): fill in the runner's default so
  // the dialog opens valid and the posted run carries explicit args.
  useEffect(() => {
    if (!readOnly && days === undefined) onChange?.({ retain_days: DEFAULT_DAYS })
  }, [readOnly, days, onChange])

  if (readOnly) {
    // A run without args (e.g. scheduled before scheduled_args was seeded) used the default.
    return (
      <Text size="sm">
        Retain runs for <b>{typeof days === 'number' ? days : `${DEFAULT_DAYS} (default)`}</b> days,
        delete older terminal runs
      </Text>
    )
  }

  return (
    <NumberInput
      label="Retain days"
      description={`Terminal runs older than this many days are deleted (${MIN_DAYS}–${MAX_DAYS})`}
      min={MIN_DAYS}
      max={MAX_DAYS}
      step={1}
      allowDecimal={false}
      value={typeof days === 'number' ? days : ''}
      onChange={(next) => onChange?.(typeof next === 'number' ? { retain_days: next } : {})}
    />
  )
}
